export default __webpack_public_path__ + "static/media/shoes1-afterA-768w.a3932f1e.webp";